/** Personal preview of the new navigation for admins, stored per browser. Default: off. */
const STORAGE_KEY = 'retis.navigationPreview';

export function isNavigationPreviewEnabled() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (error) {
    console.warn('Navigation preview: could not read the setting, preview stays off', error);
    return false;
  }
}

export function setNavigationPreviewEnabled(isEnabled) {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(isEnabled));
  } catch (error) {
    console.warn('Navigation preview: could not store the setting', error);
  }
}
